/** Production-only gate for PostHog SDK init (no localhost / staging). Fail closed if key or host missing. */
export function shouldInitPostHog(
  mode: string,
  key: string | undefined,
  host: string | undefined,
): boolean {
  if (mode !== "production") {
    return false;
  }

  if (!key?.trim()) {
    return false;
  }

  if (!host?.trim()) {
    return false;
  }

  return true;
}
